var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/node_modules/isarray/index.js
// module id = 859
// module chunks = 170